import { Injectable, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  // The current page's title as a translate KEY. Rendered by the shell's <h1> (screen-reader
  // heading) and used for the browser tab title. Defaults to the app name.
  readonly titleKey = signal<string>('App-Name')
}
